<script lang="ts">
  import { CheckCircle2, ChevronDown } from "@lucide/svelte";
  import type { Snippet } from "svelte";

  type StepState = "incomplete" | "active" | "completed";

  type Props = {
    stepNumber: number;
    title: string;
    state: StepState;
    selectionDisplay?: string;
    expanded?: boolean;
    onToggle?: () => void;
    children?: Snippet;
  };

  let { stepNumber, title, state, selectionDisplay, expanded = false, onToggle, children }: Props = $props();

  // Dynamic classes based on state
  const stepClass = $derived.by(() => {
    let classes = ["wpc-step"];
    if (state === "active") classes.push("wpc-step--active");
    if (state === "completed") classes.push("wpc-step--completed");
    if (expanded) classes.push("wpc-step--expanded");
    return classes.join(" ");
  });
</script>

<div class={stepClass}>
  <button
    type="button"
    class="wpc-step__header"
    onclick={onToggle}
    aria-expanded={expanded}
  >
    <div class="wpc-step__header-content">
      {#if state === "completed"}
        <div class="wpc-step__number">
          <CheckCircle2 size={24} />
        </div>
      {:else}
        <div class="wpc-step__number">
          {stepNumber}
        </div>
      {/if}

      <h3 class="wpc-step__title">{title}</h3>

      {#if selectionDisplay}
        <span class="wpc-step__badge">{selectionDisplay}</span>
      {/if}
    </div>

    <div class="wpc-step__icon">
      <ChevronDown size={20} />
    </div>
  </button>

  {#if expanded}
    <div class="wpc-step__content">
      {@render children?.()}
    </div>
  {/if}
</div>
